import React from 'react';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { Home, Favorites, Search } from '../screens';
import { ROUTES } from '../constants';
import CustomDrawer from '../components/CustomDrawer';
import Downloads from '../screens/Downloads';

const Drawer = createDrawerNavigator();

function DrawerNavigator () {
  return (
    <Drawer.Navigator
      drawerContent={(props) => <CustomDrawer {...props} />}
      initialRouteName={ROUTES.HOME_DRAWER}>
      <Drawer.Screen
        name={ROUTES.HOME_DRAWER}
        component={Home}
        options={{ drawerLabel: 'Letras', headerShown: false }} />
      <Drawer.Screen
        name={ROUTES.SEARCH_DRAWER}
        component={Search}
        options={{ drawerLabel: 'Search', headerShown: false }} />
      <Drawer.Screen
        name={ROUTES.FAVORITE_DRAWER}
        component={Favorites}
        options={{ drawerLabel: 'Mis favoritos', headerShown: false }} />
      <Drawer.Screen
        name={ROUTES.DOWNLOAD_DRAWER}
        component={Downloads}
        options={{ drawerLabel: 'Mis descargas', headerShown: false }} />
    </Drawer.Navigator>
  );
}

export default DrawerNavigator;
